import { BarChart, Box, Button, Flex, Loading, Text, useAppTheme } from 'ui'
import { useMemo } from 'react'
import { useSpendPerWorkerTimeseries } from 'queries/pulse/useSpendPerWorkerTimeseries'
import { usePulseContext } from '../../context/PulseProvider'
import { formatCurrency } from 'lib/string'
import { useSpendPerWorkerTimeseriesDownloadCsv } from 'queries/pulse/useSpendPerWorkerTimeseriesDownloadCsv'
import { formatTimePeriodDate } from 'pages/PulsePage/utils'

export function SpendPerWorkerTimeseries() {
  const { colors } = useAppTheme()
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useSpendPerWorkerTimeseries(filters)

  const { mutateAsync: downloadCsv, isPending: isDownloadingCsv } =
    useSpendPerWorkerTimeseriesDownloadCsv(filters)

  const chartData = useMemo(() => {
    return (data ?? []).map((item) => ({
      shift_date: formatTimePeriodDate(filters.timePeriod, item.shift_date),
      avg_spend_per_worker: item.avg_spend_per_worker,
    }))
  }, [data])

  const chartSeries = useMemo(
    () => [
      {
        name: 'avg_spend_per_worker',
        label: 'Avg Spend Per Worker',
        color: colors.primary200,
        labelColor: colors.neutrals[400],
      },
    ],
    []
  )

  return (
    <Box>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        mb={3}
      >
        <Box>
          <Text fontSize={3} fontWeight="500">
            Average Spend Per Worker
          </Text>
          <Text fontSize={2} color="lightText">
            Breakdown of spend by category, per worker
          </Text>
        </Box>
        <Button
          variant="secondary"
          onClick={() => downloadCsv()}
          loading={isDownloadingCsv}
        >
          CSV
        </Button>
      </Flex>
      {isLoading ? (
        <Box p={3}>
          <Loading />
        </Box>
      ) : (
        <BarChart
          data={chartData}
          dataKey="shift_date"
          height={450}
          series={chartSeries}
          valueFormatter={formatCurrency}
          withTooltip
          withLegend
          withPointLabels
          withXAxis
          withYAxis
        />
      )}
    </Box>
  )
}
